import React from 'react';
import { Link } from 'react-router-dom';
import LoginButton from './LoginButton';

const Header = () => {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
      return <>
  <header className="header">
    <div className="headchild" style={{ width: '13%'}}>
      <div className="logo"  >
        <Link to="/"  onClick={(e)=>{ scrollToTop()}}>
          <img src="/logo.png" style={{width:'100%'}} alt="ClevSheetsAI Logo" />
        </Link>
      </div>
    </div>
    <div className="headchild" style={{ width: '50%' }}>
      <nav>
        <ul>
          <li><a href="/#home" onClick={scrollToTop} >Home</a></li>
          <li><a href="/#features">Features</a></li>
          <li><a href="/#tutorial">Tutorial</a></li>
          <li><a href="/#pricing">Pricing</a></li>
          <li><a href="/#contact">Contact</a></li>
        </ul>
      </nav>
    </div>
    <div>
      <LoginButton/>
    </div>
  </header>
      </>
};

export default Header;
